module.exports = __webpack_public_path__ + "img/Nangka-J33.9f901a65.jpg";